import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';

import { InfoField, ChipBox } from '@occc-app/design-system';
import { EarningMechanismProductDiscountFragment } from '@occc/graphql';

interface IProductDiscountProps {
  earningMechanism: EarningMechanismProductDiscountFragment;
}
const formatPurchaseThreshold = ({
  purchaseThresholdInt,
}: {
  purchaseThresholdInt: EarningMechanismProductDiscountFragment['purchaseThresholdInt'];
}): string => `${purchaseThresholdInt}`;

export const ProductDiscount: React.FC<IProductDiscountProps> = ({ earningMechanism }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField
          disableTypography
          label='Included Product Groups'
          value={
            <ChipBox items={earningMechanism.eligibleProductGroups} onClick={onChipClick} mt={0} />
          }
        />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Purchase Threshold' value={formatPurchaseThreshold(earningMechanism)} />
      </Grid>
    </Grid>
  );
};
